import { compose } from 'react-apollo';

import ConstraintModalContainer from './ConstraintModalContainer';
import { withProcedure, withSpecialty } from '../../../../gql';

export default compose(
    withProcedure({
        ownProp: 'searchProcedureId',
        mapResultToPropName: 'searchProcedure',
    }),
    withSpecialty({
        ownProp: 'searchSpecialtyId',
        mapResultToPropName: 'searchSpecialty',
    }),
)(ConstraintModalContainer);
